var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-admin-wrap layout-sidebar-compact   clearfix",class:[
    _vm.getCompactSideBarToggleProperties.isSideNavOpen ? 'sidenav-open' : '',
    _vm.getcompactLeftSideBarBgColor
  ]},[_c('compactSidebar'),_c('div',{staticClass:"main-content-wrap d-flex flex-column"},[_c('compactTopbar'),_c('transition',{attrs:{"name":"page","mode":"out-in"}},[_c('router-view')],1),_c('appFooter')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }